import mutations from './mutations'
import state from './state'
import getters from './getters'

const auth = {
  namespaced: true,

  state,
  mutations,
  getters
}

export default auth
